import React, { useState } from "react";
import { GoogleLogin } from "@react-oauth/google";
import axios from "axios";
import Swal from "sweetalert2";
import API_BASE from "../config/api";

function Login() {
    const [form, setForm] = useState({
        email: "",
        password: "",
    });

    const [loading, setLoading] = useState(false);

    // SMALL TOAST ALERT FUNCTION
    const showToast = (message, icon) => {
        Swal.fire({
            toast: true,
            position: "top-end",
            icon: icon,
            title: message,
            showConfirmButton: false,
            timer: 1500,
            customClass: {
                popup:
                    icon === "success"
                        ? "my-toast my-toast-success"
                        : icon === "error"
                            ? "my-toast my-toast-error"
                            : "my-toast my-toast-warning",
            },
        });
    };


    const handleChange = (e) =>
        setForm({ ...form, [e.target.name]: e.target.value });

    // -------------------------
    // EMAIL LOGIN
    // -------------------------
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!form.email || !form.password) {
            showToast("Email & Password are required", "warning");
            return;
        }

        setLoading(true);
        try {
            const res = await fetch(`${API_BASE}/api/login.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(form),
            });

            const data = await res.json();
            setLoading(false);

            if (data.success) {
                if (data.user) {
                    localStorage.setItem("user", JSON.stringify(data.user));
                }

                showToast(data.message, "success");

                setTimeout(() => {
                    window.location.href = "/";
                }, 1200);
            } else {
                showToast(data.message, "error");
            }
        } catch (err) {
            setLoading(false);
            showToast("Server Error. Please try again.", "error");
        }
    };

    // -------------------------
    // GOOGLE LOGIN
    // -------------------------
    const handleGoogle = async (cred) => {
        try {
            const res = await axios.post(
                `${API_BASE}/api/google_register.php`,
                { token: cred.credential }
            );

            if (res.data.success) {
                if (res.data.user) {
                    localStorage.setItem("user", JSON.stringify(res.data.user));
                }

                showToast("Google login successful", "success");

                setTimeout(() => {
                    window.location.href = "/";
                }, 1200);
            } else {
                showToast(res.data.message, "error");
            }
        } catch (err) {
            showToast("Google login failed", "error");
        }
    };

    return (
        <div className="container py-5 d-flex justify-content-center">
            <div
                className="p-5 shadow-lg rounded-4 bg-white"
                style={{
                    maxWidth: "500px",
                    width: "100%",
                    borderTop: "5px solid #1E49FF",
                }}
            >
                <div className="text-center mb-4">
                    <img src="/logo.png" alt="Logo" style={{ width: "120px" }} />
                </div>

                <h2
                    className="text-center fw-bold mb-4"
                    style={{ color: "#1E49FF" }}
                >
                    Welcome Back 👋
                </h2>

                {/* Google Login */}
                <div className="d-flex justify-content-center mb-3">
                    <GoogleLogin
                        onSuccess={handleGoogle}
                        onError={() => showToast("Google Login Failed", "error")}
                    />
                </div>

                <p className="text-center text-muted mb-4">OR LOGIN WITH EMAIL</p>

                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label className="form-label fw-semibold">Email</label>
                        <input
                            type="email"
                            name="email"
                            className="form-control border-2 border-primary rounded-pill shadow-sm"
                            value={form.email}
                            onChange={handleChange}
                            placeholder="Enter your email"
                        />
                    </div>

                    <div className="mb-4">
                        <label className="form-label fw-semibold">Password</label>
                        <input
                            type="password"
                            name="password"
                            className="form-control border-2 border-primary rounded-pill shadow-sm"
                            value={form.password}
                            onChange={handleChange}
                            placeholder="Enter password"
                        />
                    </div>

                    <button
                        type="submit"
                        className="btn w-100 py-2 fw-bold text-white"
                        style={{
                            background:
                                "linear-gradient(90deg, #1E49FF, #08f7fe)",
                            borderRadius: "50px",
                            fontSize: "16px",
                        }}
                    >
                        {loading ? "Logging in..." : "Login"}
                    </button>

                    <p className="text-center mt-3">
                        Don't have an account?{" "}
                        <a href="/register" className="fw-bold text-primary">
                            Register
                        </a>
                    </p>

                    <p className="text-center mt-2">
                        <a href="/" className="fw-bold text-secondary">
                            Back to Home
                        </a>
                    </p>
                </form>
            </div>

            {/* SMALL TOAST CSS */}
            <style>{`
                .small-swal {
                    padding: 6px 12px !important;
                    font-size: 14px !important;
                    border-radius: 6px !important;
                    min-height: 40px !important;
                }
                    .my-toast {
                    padding: 10px 16px !important;
                    font-size: 15px !important;
                    border-radius: 8px !important;
                    min-height: 45px !important;
                    box-shadow: 0px 3px 10px rgba(0,0,0,0.15) !important;
                }

                .my-toast-success {
                    background: #d4f8d4 !important;
                    border-left: 5px solid #28a745 !important;
                    color: #155724 !important;
                }

                .my-toast-error {
                    background: #fde2e2 !important;
                    border-left: 5px solid #dc3545 !important;
                    color: #721c24 !important;
                }

                .my-toast-warning {
                    background: #fff3cd !important;
                    border-left: 5px solid #ff9800 !important;
                    color: #7a5200 !important;
                }

                            `}</style>
        </div>
    );
}

export default Login;
